// src/pages/CreateScript.js
import React, { useState } from "react";
import ScriptBuilder from "./Script.js"; // reuse your existing text prompt builder
import Workflow from "./Workflow.js"; // your conversation flow editor

export default function CreateScript() {
  const [selectedType, setSelectedType] = useState(null);

  // Reset selection when clicking back
  const handleBack = () => {
    setSelectedType(null);
  };

  // --- Initial type selection screen ---
  if (!selectedType) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50">
        <h1 className="text-2xl font-bold mb-6">Create a New Script</h1>
        <div className="flex gap-6">
          <button
            onClick={() => setSelectedType("Text Prompt")}
            className="bg-cyan-400 hover:bg-blue-700 text-white px-6 py-3 rounded-md text-lg"
          >
            Text Prompt
          </button>
          <button
            onClick={() => setSelectedType("Conversation Flow")}
            className="bg-cyan-400 hover:bg-blue-700 text-white px-6 py-3 rounded-md text-lg"
          >
            Conversation Flow
          </button>
        </div>
      </div>
    );
  }

  // --- Text Prompt Builder ---
  if (selectedType === "Text Prompt") {
    return (
      <div className="min-h-screen bg-gray-50">
        <div className="p-4 bg-white shadow flex justify-between items-center">
          <button
            onClick={handleBack}
            className="px-4 py-2 rounded-md bg-gray-200 hover:bg-gray-300"
          >
            ← Back
          </button>
          <h2 className="text-lg font-semibold">New Text Prompt Script</h2>
          <div></div>
        </div>
        <ScriptBuilder />
      </div>
    );
  }

  // --- Conversation Flow Editor ---
  if (selectedType === "Conversation Flow") {
    return (
      <div className="min-h-screen bg-gray-50">
        <div className="p-4 bg-white shadow flex justify-between items-center">
          <button
            onClick={handleBack}
            className="px-4 py-2 rounded-md bg-gray-200 hover:bg-gray-300"
          >
            ← Back
          </button>
          <h2 className="text-lg font-semibold">New Conversation Flow Script</h2>
          <div></div>
        </div>
        <Workflow />
      </div>
    );
  }

  return null;
}
